module.exports = __webpack_public_path__ + "img/2.5e61d1c0.jpg";